import { Pinia, Store } from '../pinia-class-component';

export type ConfirmFallbackContext = {
  v2LaunchAttempted: boolean;
  v2LaunchFailed: boolean;
};

export function useDeprecationGateStore() {
  return new DeprecationGateStore();
}

// Deliberately not persisted; resets only when the bundle is re-evaluated (cold start / webview reload).
@Store
class DeprecationGateStore extends Pinia {
  private _fallbackConfirmed: boolean;

  constructor() {
    super();
    this._fallbackConfirmed = false;
  }

  get fallbackConfirmed(): boolean {
    return this._fallbackConfirmed;
  }

  confirmFallback(context: ConfirmFallbackContext): void {
    this._fallbackConfirmed = true;
  }
}
